import React from "react";
import { Tooltip, Collapse } from "antd";
import { useCanvas } from "../../context/canvasContext";
import { useParams } from "react-router-dom";
import './antSidebar.css';

const { Panel } = Collapse;

const ShapesModal = ({ isShapeModalVisible, setIsShapeModalVisible, shapes }) => {
  const isMobile = window.screen.width < 768;

  const { createCircle, createRectangle, createTriangle, createEllipse, createSquare, createCylinder, createRightAngleTriangle, createDiamond, createRightArrow } = useCanvas();

  const { id } = useParams();

  const createShape = (shapeName) => {
    shapeName = shapeName.trim().toLowerCase();
    switch (shapeName) {
      case 'circle': createCircle(id); break;
      case 'rectangle': createRectangle(id); break;
      case 'ellipse': createEllipse(id); break;
      case 'square': createSquare(id); break;
      case 'triangle': createTriangle(id); break;
      case 'cylinder': createCylinder(id); break;
      case 'right-angle-triangle': createRightAngleTriangle(id); break;
      case 'diamond': createDiamond(id); break;
      case 'arrow': createRightArrow(id); break;
      default: console.log('Shape not recognized');
    }
  }

  if (!isShapeModalVisible) {
    return null;
  }

  const handleCollapseChange = (key) => {
    if (key.length === 0) {
      setIsShapeModalVisible(false);
    }
  };

  return (
    <div style={{
      width: isMobile ? '155px' : '168px',
      position: isMobile ? 'absolute' : '',
      top: isMobile ? '-290px' : '',
      right: isMobile ? "40px" : '',
      boxShadow: "rgb(101 92 92 / 50%) 0px 3px 8px",
      borderRadius: "5px",
    }}>
      <Collapse
        bordered={true}
        expandIconPosition="right"
        defaultActiveKey={['1']}
        onChange={handleCollapseChange}
      >
        <Panel
          style={{ fontSize: isMobile ? '11px' : '13px' }}
          header="Shapes"
          key="1"
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', cursor: 'pointer' }}>
            {shapes.map((shape) => (
              <Tooltip key={shape.id} title={shape.name}>
                <div
                  style={{
                    margin: shape.name === 'triangle' ? '4px 12px' :
                      (shape.name === 'rectangle' ? '5px 10px' : "10px"),
                  }}
                  onClick={() => createShape(shape.name)}
                >{shape.image}</div>
              </Tooltip>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default ShapesModal;
